import React from 'react';
import type { Park } from '../types';
import { useApp } from '../context/PetParksContext';
import { ParkCard } from './ParkCard';
import { EmptyState } from './EmptyState';
import { ScrollArea } from './ui/scroll-area';

interface ListViewProps {
  parks: Park[];
  onParkSelect: (park: Park) => void;
}

export const ListView: React.FC<ListViewProps> = ({ parks, onParkSelect }) => {
  const { t } = useApp();

  if (parks.length === 0) {
    return (
      <EmptyState
        type="no-parks"
        title={t('noParksNearby')}
        description={t('tryAdjustingFilters')}
      />
    );
  }

  return (
    <ScrollArea className="h-full min-w-0">
      <div className="p-3 sm:p-4 min-w-0">
        {parks.map((park) => (
          <div key={park.id} className="py-2 sm:py-3 min-w-0">
            <ParkCard park={park} onClick={() => onParkSelect(park)} />
          </div>
        ))}
      </div>
    </ScrollArea>
  );
};
